import React from 'react';
import './Rate.css';
import Calc from '../Calc/Calc';

const Rate = (props) => {

  return (
    <div className='rate'>
      <div className="flex-container">
        {Object.keys(props.currencyRate).map((keyName, i) => (
          <div className="block flex-item" key={keyName}>
            <div className="currency-name">{keyName}</div>
            <div className="currency-in">{props.currencyRate[keyName].toFixed(2)}</div>
            <p>* Можно купить за 1 {props.base}</p>
          </div>
        ))}
      </div>
      <Calc rate={props.currencyRate} calculated={props.calculated} calcRate={props.calcRate} base={props.base} />
    </div>
  );
}

export default Rate;
